import banners from "./banners";
import boards from "./boards";
import center from "./center";
import companies from "./companies";
import contracts from "./contracts";
import estimate from "./estimate";
import holidays from "./holidays";
import levels from "./levels";
import messages from "./messages";
import popups from "./popups";
import portfolios from "./portfolios";
import setting from "./setting";
import shop from "./shop";
import statistics from "./statistics";
import terms from "./terms";
import users from "./users";

export default {
    banners,
    boards,
    center,
    companies,
    contracts,
    estimate,
    holidays,
    levels,
    messages,
    popups,
    portfolios,
    setting,
    shop,
    statistics,
    terms,
    users,
};
